/**
 * Collection sort control.
 *
 * Rewrites the URL in place so every applied filter survives the switch;
 * `page` is dropped because page 4 of one ordering is a meaningless place
 * in another. A module rather than an inline handler to match how every
 * other control in this theme is wired.
 */
class SortSelect extends HTMLElement {
  connectedCallback() {
    this.querySelector('select')?.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.querySelector('select')?.removeEventListener('change', this.#onChange);
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const select = /** @type {HTMLSelectElement} */ (event.target);
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url);
  };
}

if (!customElements.get('tt-sort-select')) {
  customElements.define('tt-sort-select', SortSelect);
}
